module.exports = __webpack_public_path__ + "static/media/squire-logo-light.e18b9f42.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/squire-logo-light.svg
// module id = 309
// module chunks = 0